import token from 'styled-token';

/** @mixin focusMixin */
/**
 * Add custom focus styling to the component.
 *
 * @example
 * import { focusMixin } from '@zillow/constellation';
 *
 * const Component = styled.button`
 *     ${focusMixin}
 * `;
 *
 * <Component>Custom focus styling</Component>
 *
 * @method
 */
export var focusMixin = function focusMixin(props) {
  return "\n    outline: none;\n    box-shadow: none;\n    &:focus-visible {\n        box-shadow: " + (token('shadows.focus')(props) || '') + ";\n    }\n    @supports not selector(:focus-visible) {\n        &:focus {\n            box-shadow: " + (token('shadows.focus')(props) || '') + ";\n        } \n    }\n";
};